import { useState } from 'react';

const reviews = [
  {
    id: 1,
    name: '김○○ 님',
    location: '서울시',
    rating: 5,
    img: 'https://cdn.imweb.me/thumbnail/20251206/bccf357889cde.jpg',
    text: '절차가 간단해서 너무 좋았습니다. 복잡할 줄 알았는데 한 번 설명 듣고 진행하니 간병인 연결부터 서류 발급까지 금방 끝났습니다. 특히 서류 챙길 필요 없이 코리아케어러스에서 알아서 준비해준다는 게 제일 좋았어요.',
  },
  {
    id: 2,
    name: '이○○ 님',
    location: '인천시',
    rating: 5,
    img: 'https://cdn.imweb.me/thumbnail/20251206/7f0588fbfdf89.jpg',
    text: '할머니가 입원하신 뒤 가족들이 돌아가며 간병했는데 너무 힘들었거든요. 코리아케어러스를 이용하면서 외부 도움을 처음 받아봤는데, 간병인 분도 성실하시고 전체적으로 믿을 수 있었어요.',
  },
  {
    id: 3,
    name: '박○○ 님',
    location: '대전시',
    rating: 5,
    img: 'https://cdn.imweb.me/thumbnail/20251206/393b61e2c6111.jpg',
    text: '간병과 서류 걱정을 한꺼번에 덜었어요. 부모님 병간호와 회사 업무를 병행하기가 너무 힘들었는데, 이 서비스 덕분에 숨통이 트였어요. 간병인 매칭도 빠르고, 보험 청구 서류를 알아서 준비해줘서 따로 신경 쓸 게 없었습니다.',
  },
  {
    id: 4,
    name: '최○○ 님',
    location: '경기도 수원시',
    rating: 5,
    img: 'https://cdn.imweb.me/thumbnail/20251206/c99c50b23fd08.jpg',
    text: '일 때문에 병원에 오래 있지 못했는데, 간병인을 쉽게 연결해주고 보험 서류도 알아서 챙겨줘서 정말 감사했어요. 예전엔 병원에서 퇴근하자마자 다시 서류 챙기러 다녔는데, 이번엔 그런 스트레스가 전혀 없었습니다.',
  },
  {
    id: 5,
    name: '정○○ 님',
    location: '부산시',
    rating: 5,
    img: 'https://cdn.imweb.me/thumbnail/20251206/8328b92a2cb8b.jpg',
    text: '어머니가 입원하시고 급히 간병인을 구해야 했는데, 지인 소개로 이 서비스를 알게 됐어요. 연락하고 얼마 안 있어 간병인이 바로 오셨고, 덕분에 가족들 모두 돌아가면서 간병하던 부담이 줄었습니다.',
  },
];

export default function ReviewsSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? reviews.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === reviews.length - 1 ? 0 : c + 1));

  const visible = [
    reviews[current % reviews.length],
    reviews[(current + 1) % reviews.length],
    reviews[(current + 2) % reviews.length],
  ];

  return (
    <section className="w-full py-16" style={{ backgroundColor: '#f9fdfb' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: '#2E7D6B' }}>REVIEWS</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">고객님들의 생생한 후기</h2>
          </div>
          <div className="flex gap-2">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-xl border border-gray-200 cursor-pointer hover:border-[#2E7D6B] transition-colors"
            >
              <i className="ri-arrow-left-s-line text-gray-600"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-xl border border-gray-200 cursor-pointer hover:border-[#2E7D6B] transition-colors"
            >
              <i className="ri-arrow-right-s-line text-gray-600"></i>
            </button>
          </div>
        </div>

        {/* Desktop: 3 cards */}
        <div className="hidden md:grid grid-cols-3 gap-5">
          {visible.map((review, i) => (
            <div key={`${review.id}-${i}`} className="bg-white rounded-2xl overflow-hidden border border-gray-100 flex flex-col">
              <div className="w-full h-44 overflow-hidden">
                <img src={review.img} alt="고객 후기" className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <p className="text-sm font-bold text-gray-900">{review.name}</p>
                    <p className="text-xs text-gray-400 flex items-center gap-1 mt-0.5">
                      <i className="ri-map-pin-2-line text-xs" style={{ color: '#2E7D6B' }}></i>
                      {review.location}
                    </p>
                  </div>
                  <div className="flex gap-0.5">
                    {Array.from({ length: review.rating }).map((_, si) => (
                      <i key={si} className="ri-star-fill text-yellow-400 text-xs"></i>
                    ))}
                  </div>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed line-clamp-4 flex-1">{review.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile: single */}
        <div className="md:hidden">
          <div className="bg-white rounded-2xl overflow-hidden border border-gray-100">
            <div className="w-full h-52">
              <img src={reviews[current].img} alt="고객 후기" className="w-full h-full object-cover object-top" />
            </div>
            <div className="p-5">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="text-sm font-bold text-gray-900">{reviews[current].name}</p>
                  <p className="text-xs text-gray-400 flex items-center gap-1 mt-0.5">
                    <i className="ri-map-pin-2-line text-xs" style={{ color: '#2E7D6B' }}></i>
                    {reviews[current].location}
                  </p>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: reviews[current].rating }).map((_, si) => (
                    <i key={si} className="ri-star-fill text-yellow-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">{reviews[current].text}</p>
            </div>
          </div>
          <div className="flex justify-between items-center mt-4">
            <button onClick={prev} className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 cursor-pointer">
              <i className="ri-arrow-left-s-line text-gray-600"></i>
            </button>
            <div className="flex gap-2">
              {reviews.map((_, i) => (
                <button key={i} onClick={() => setCurrent(i)} className="cursor-pointer transition-all" style={{ width: i === current ? '24px' : '8px', height: '4px', borderRadius: '2px', backgroundColor: i === current ? '#2E7D6B' : '#d1d5db' }} />
              ))}
            </div>
            <button onClick={next} className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 cursor-pointer">
              <i className="ri-arrow-right-s-line text-gray-600"></i>
            </button>
          </div>
        </div>

        {/* Dots desktop */}
        <div className="hidden md:flex justify-center gap-2 mt-6">
          {reviews.map((_, i) => (
            <button key={i} onClick={() => setCurrent(i)} className="cursor-pointer transition-all" style={{ width: i === current ? '24px' : '8px', height: '4px', borderRadius: '2px', backgroundColor: i === current ? '#2E7D6B' : '#d1d5db' }} />
          ))}
        </div>
      </div>
    </section>
  );
}
